/* ============================================================================
   SM WORD — Page « Comparer » : comportements (assets/smw-compare-page.js)

   Lit les produits dans <script data-smw-cmp-data> (JSON produit par la
   section Liquid), puis construit :
   - des onglets par type de produit (casques, projecteurs, manettes…) ;
   - jusqu'à 3 colonnes, chacune avec un menu pour choisir le modèle ;
   - photo, nom, prix, coloris, boutons « Acheter » / « En savoir plus » ;
   - les lignes de caractéristiques, masquées quand aucun modèle choisi
     n'a de valeur.

   Vanilla JS, aucune dépendance, aucun effet hors de la page Comparer :
   le script ne fait rien s'il ne trouve pas [data-smw-cmp].
   Sans JavaScript, la liste de produits (avec liens) reste affichée.
   ========================================================================== */
(function () {
  'use strict';

  if (window.__smwCompareLoaded) return;
  window.__smwCompareLoaded = true;

  var SLOTS = 3;

  var TYPE_LABELS = {
    'Casque audio': 'Casques',
    'Vidéoprojecteur': 'Vidéoprojecteurs',
    'Manette de jeu': 'Manettes',
    'Projecteur': 'Projecteurs'
  };

  var GROUPS = [
    { title: 'En résumé', rows: [
      ['ideal_pour', 'Idéal pour'], ['distinction', 'Ce qui le distingue'], ['gamme', 'Gamme']
    ] },
    { title: 'Conception', rows: [
      ['poids', 'Poids'], ['joysticks', 'Joysticks'], ['moteur_optique', 'Moteur optique'],
      ['focale', 'Focale'], ['taille_image', 'Taille d\'image']
    ] },
    { title: 'Technologie', rows: [
      ['resolution_native', 'Résolution native'], ['luminosite_ansi', 'Luminosité'],
      ['reduction_de_bruit', 'Réduction de bruit'], ['son', 'Son'],
      ['retour_haptique', 'Retour haptique'], ['systeme', 'Système']
    ] },
    { title: 'Autonomie', rows: [
      ['autonomie', 'Autonomie'], ['recharge', 'Recharge']
    ] },
    { title: 'Connectivité', rows: [
      ['bluetooth', 'Bluetooth'], ['connexion', 'Connexion'],
      ['compatibilite', 'Compatibilité'], ['connectique', 'Connectique']
    ] },
    { title: 'Confiance', rows: [
      ['certifications', 'Certifications'], ['garantie', 'Garantie']
    ] }
  ];

  function el(tag, cls, text) {
    var node = document.createElement(tag);
    if (cls) node.className = cls;
    if (text !== undefined && text !== null) node.textContent = text;
    return node;
  }

  function hasValue(value) {
    if (value === null || value === undefined) return false;
    if (Object.prototype.toString.call(value) === '[object Array]') {
      return value.join('').replace(/\s+/g, '') !== '';
    }
    return String(value).replace(/\s+/g, '') !== '';
  }

  function formatValue(value) {
    if (!hasValue(value)) return '';
    if (Object.prototype.toString.call(value) === '[object Array]') {
      return value.join(' · ');
    }
    return String(value).trim().replace(/\s*\n\s*/g, ' · ');
  }

  /* Prix : formaté avec la devise du pays du visiteur, comme le tiroir panier
     (« 54,99 € », « 59,00 $US »). Repli : la chaîne formatée par Shopify. */
  function formatPrice(product, currency, locale) {
    try {
      if (typeof product.price_cents === 'number' && currency) {
        return new Intl.NumberFormat(locale || 'fr-FR', { style: 'currency', currency: currency })
          .format(product.price_cents / 100);
      }
    } catch (error) { /* repli ci-dessous */ }
    return product.price;
  }

  function init(root) {
    var dataNode = root.querySelector('script[data-smw-cmp-data]');
    var mount = root.querySelector('[data-smw-cmp-app]');
    if (!dataNode || !mount) return;

    var products = [];
    try {
      products = JSON.parse(dataNode.textContent) || [];
    } catch (error) {
      return; // JSON illisible : la liste de liens reste affichée
    }

    var currency = root.getAttribute('data-currency') || '';
    var locale = root.getAttribute('data-locale') || 'fr-FR';
    var isEnglish = String(locale).toLowerCase().indexOf('en') === 0;
    var EN_LABELS = {
      'Casques': 'Headphones', 'Vidéoprojecteurs': 'Video projectors',
      'Manettes': 'Gamepads', 'Projecteurs': 'Video projectors',
      'En résumé': 'At a glance', 'Idéal pour': 'Best for',
      'Ce qui le distingue': 'What sets it apart', 'Gamme': 'Range',
      'Conception': 'Design', 'Poids': 'Weight', 'Moteur optique': 'Optical engine',
      'Focale': 'Throw ratio', "Taille d'image": 'Image size',
      'Technologie': 'Technology', 'Résolution native': 'Native resolution',
      'Luminosité': 'Brightness', 'Réduction de bruit': 'Noise cancellation',
      'Son': 'Sound', 'Retour haptique': 'Haptic feedback', 'Système': 'Operating system',
      'Autonomie': 'Battery life', 'Recharge': 'Charging',
      'Connectivité': 'Connectivity', 'Connexion': 'Connection',
      'Compatibilité': 'Compatibility', 'Connectique': 'Ports',
      'Confiance': 'Trust', 'Garantie': 'Warranty'
    };
    function localLabel(value) {
      return isEnglish && EN_LABELS[value] ? EN_LABELS[value] : value;
    }

    var labels = {
      empty: root.getAttribute('data-empty-value') || '—',
      buy: root.getAttribute('data-buy-label') || 'Acheter',
      more: root.getAttribute('data-more-label') || 'En savoir plus',
      unavailable: root.getAttribute('data-unavailable-label') || 'Indisponible',
      noRows: root.getAttribute('data-no-rows-label') || '',
      colors: root.getAttribute('data-colors-label') || 'Coloris',
      add: root.getAttribute('data-add-label') || 'Ajouter un modèle'
    };

    var byHandle = {};
    var counts = {};
    var types = [];
    products.forEach(function (product) {
      byHandle[product.handle] = product;
      if (!product.type) return;
      counts[product.type] = (counts[product.type] || 0) + 1;
      if (types.indexOf(product.type) === -1) types.push(product.type);
    });
    // On ne propose que les types qui ont au moins 2 modèles à comparer.
    types = types.filter(function (type) { return counts[type] >= 2; });
    if (!types.length) return;

    function ofType(type) {
      return products.filter(function (product) { return product.type === type; });
    }

    /* Choix initial : deux modèles, troisième facultatif. Les liens partagés
       gardent la sélection jusqu'à trois modèles. */
    function pick(type, wanted) {
      var list = ofType(type);
      var out = [];
      wanted.forEach(function (handle) {
        var product = byHandle[handle];
        if (product && product.type === type && out.indexOf(handle) === -1 && out.length < SLOTS) {
          out.push(handle);
        }
      });
      var ordered = list.filter(function (p) { return p.available; })
        .concat(list.filter(function (p) { return !p.available; }));
      ordered.forEach(function (product) {
        if (out.length < Math.max(2, Math.min(SLOTS, wanted.filter(Boolean).length)) && out.indexOf(product.handle) === -1) out.push(product.handle);
      });
      while (out.length < SLOTS) out.push(null);
      return out;
    }

    var state = { type: types[0], slots: [], differencesOnly: false };

    /* Sélection de départ : ?produit=<handle> (depuis une fiche) ou
       ?m=<h1>,<h2>,<h3> (lien partagé). */
    var query = {};
    try {
      var params = new URLSearchParams(window.location.search);
      query.produit = params.get('produit') || '';
      query.m = params.get('m') || '';
    } catch (error) {
      query.produit = '';
      query.m = '';
    }
    var wanted = query.m.split(',').filter(Boolean);
    if (query.produit) wanted.unshift(query.produit);
    var firstProduct = wanted.length ? byHandle[wanted[0]] : null;
    if (firstProduct && types.indexOf(firstProduct.type) !== -1) {
      state.type = firstProduct.type;
      state.slots = pick(state.type, wanted);
    } else {
      state.slots = pick(state.type, []);
    }

    function syncUrl() {
      try {
        var handles = state.slots.filter(Boolean).join(',');
        var params = new URLSearchParams(window.location.search);
        params.delete('produit');
        if (handles) params.set('m', handles); else params.delete('m');
        var queryString = params.toString();
        window.history.replaceState(null, '',
          window.location.pathname + (queryString ? '?' + queryString : '') + (window.location.hash || ''));
      } catch (error) { /* sans importance */ }
    }

    function compact() {
      var kept = state.slots.filter(Boolean);
      while (kept.length < SLOTS) kept.push(null);
      state.slots = kept;
    }

    function setSlot(index, handle) {
      var value = handle || null;
      if (value && state.slots.indexOf(value) !== -1 && state.slots[index] !== value) return;
      state.slots[index] = value;
      compact();
      render();
      syncUrl();
      var selects = mount.querySelectorAll('.smw-cmp__select');
      if (selects[Math.min(index, selects.length - 1)]) selects[Math.min(index, selects.length - 1)].focus();
    }

    function setType(type) {
      state.type = type;
      state.slots = pick(type, []);
      render();
      syncUrl();
      // Replacing the category buttons otherwise discards keyboard focus.
      var activeTab = mount.querySelector('.smw-cmp__type[aria-pressed="true"]');
      if (activeTab) activeTab.focus();
    }

    function renderTypes() {
      var bar = el('div', 'smw-cmp__types');
      bar.setAttribute('role', 'group');
      bar.setAttribute('aria-label', isEnglish ? 'Product type' : 'Type de produit');
      types.forEach(function (type) {
        var button = el('button', 'smw-cmp__type', localLabel(TYPE_LABELS[type] || type));
        button.type = 'button';
        button.setAttribute('aria-pressed', type === state.type ? 'true' : 'false');
        button.addEventListener('click', function () {
          if (type !== state.type) setType(type);
        });
        bar.appendChild(button);
      });
      return bar;
    }

    function renderSelect(index, product) {
      var select = el('select', 'smw-cmp__select');
      select.setAttribute('aria-label', (isEnglish ? 'Model ' : 'Modèle ') + (index + 1));
      var blank = el('option', null, labels.add);
      blank.value = '';
      select.appendChild(blank);
      ofType(state.type).forEach(function (item) {
        var text = item.title + (item.available ? '' : ' (' + labels.unavailable.toLowerCase() + ')');
        var option = el('option', null, text);
        option.value = item.handle;
        if (product && product.handle === item.handle) option.selected = true;
        if (state.slots.indexOf(item.handle) !== -1 && (!product || product.handle !== item.handle)) {
          option.disabled = true;
          option.textContent = item.title + (isEnglish ? ' (already selected)' : ' (déjà sélectionné)');
        }
        select.appendChild(option);
      });
      select.addEventListener('change', function () {
        setSlot(index, select.value);
      });
      return select;
    }

    function renderCard(index) {
      var handle = state.slots[index];
      var product = handle ? byHandle[handle] : null;
      var card = el('div', 'smw-cmp__card' + (product ? '' : ' is-empty'));
      card.setAttribute('data-slot', String(index + 1));
      card.appendChild(renderSelect(index, product));
      if (!product) {
        card.appendChild(el('div', 'smw-cmp__placeholder', isEnglish ? 'Choose a third model to compare' : 'Ajoutez un troisième modèle à comparer'));
        return card;
      }

      var media = el('a', 'smw-cmp__media');
      media.href = product.url;
      if (product.image) {
        var img = el('img');
        img.src = product.image;
        img.alt = product.title;
        img.loading = 'lazy';
        media.appendChild(img);
      }
      card.appendChild(media);

      var name = el('a', 'smw-cmp__name', product.title);
      name.href = product.url;
      name.title = product.title;
      card.appendChild(name);

      card.appendChild(el('p', 'smw-cmp__price', formatPrice(product, currency, locale)));

      if (product.colors && product.colors.length) {
        card.appendChild(el('p', 'smw-cmp__colors',
          labels.colors + ' : ' + product.colors.join(' · ')));
      }

      var actions = el('div', 'smw-cmp__actions');
      if (product.available) {
        var buy = el('a', 'smw-cmp__btn', isEnglish ? 'Choose this model' : 'Choisir ce modèle');
        buy.href = product.url;
        buy.setAttribute('aria-label', (isEnglish ? 'Open product page: ' : 'Ouvrir la fiche produit : ') + product.title);
        actions.appendChild(buy);
      } else {
        actions.appendChild(el('span', 'smw-cmp__soldout', labels.unavailable));
      }
      var more = el('a', 'smw-cmp__link', isEnglish ? 'Product details ↗' : 'Voir les caractéristiques ↗');
      more.href = product.url + '#SmProductDetails';
      actions.appendChild(more);
      card.appendChild(actions);
      return card;
    }

    function renderTable() {
      var chosen = state.slots.map(function (handle) {
        return handle ? byHandle[handle] : null;
      });
      var active = chosen.filter(Boolean);
      var table = el('div', 'smw-cmp__table');

      GROUPS.forEach(function (group) {
        var rows = group.rows.filter(function (row) {
          var populated = active.some(function (product) {
            return product.meta && hasValue(product.meta[row[0]]);
          });
          if (!populated) return false;
          if (!state.differencesOnly || active.length < 2) return true;
          var vals = active.map(function (p) {
            return p.meta ? formatValue(p.meta[row[0]]) : '';
          });
          return vals.some(function (value) { return value !== vals[0]; });
        });
        if (!rows.length) return;

        table.appendChild(el('h3', 'smw-cmp__group', localLabel(group.title)));
        rows.forEach(function (row) {
          var line = el('div', 'smw-cmp__row');
          line.appendChild(el('div', 'smw-cmp__label', localLabel(row[1])));
          var cells = el('div', 'smw-cmp__cells');
          chosen.forEach(function (product, index) {
            var value = product && product.meta ? formatValue(product.meta[row[0]]) : '';
            var cell = el('div', 'smw-cmp__cell' + (value ? '' : ' is-empty'), value || labels.empty);
            cell.setAttribute('data-slot', String(index + 1));
            cells.appendChild(cell);
          });
          line.appendChild(cells);
          table.appendChild(line);
        });
      });

      if (!table.children.length && labels.noRows) {
        table.appendChild(el('p', 'smw-cmp__note', state.differencesOnly ? (isEnglish ? 'No differences in the available specifications.' : 'Aucune différence parmi les caractéristiques renseignées.') : (labels.noRows || (isEnglish ? 'No comparable specifications available.' : 'Aucune caractéristique comparable renseignée.'))));
      }
      return table;
    }

    function render() {
      while (mount.firstChild) mount.removeChild(mount.firstChild);
      mount.appendChild(renderTypes());
      var toolbar = el('div', 'smw-cmp__toolbar');
      var info = el('p', 'smw-cmp__hint', isEnglish ? 'Compare two models or add a third · Swipe on mobile' : 'Comparez deux modèles, ou ajoutez-en un troisième · Glissez sur mobile');
      toolbar.appendChild(info);
      var buttons = el('div', 'smw-cmp__toolbar-buttons');
      var difference = el('button', 'smw-cmp__utility', isEnglish ? 'Differences only' : 'Différences uniquement');
      difference.type = 'button';
      difference.setAttribute('aria-pressed', state.differencesOnly ? 'true' : 'false');
      difference.addEventListener('click', function () {
        state.differencesOnly = !state.differencesOnly;
        render();
        var next = mount.querySelector('[data-cmp-action="differences"]');
        if (next) next.focus();
      });
      difference.setAttribute('data-cmp-action', 'differences');
      buttons.appendChild(difference);
      var reset = el('button', 'smw-cmp__utility', isEnglish ? 'Reset' : 'Réinitialiser');
      reset.type = 'button';
      reset.addEventListener('click', function () {
        state.slots = pick(state.type, []);
        state.differencesOnly = false;
        render();
        syncUrl();
        var next = mount.querySelector('[data-cmp-action="reset"]');
        if (next) next.focus();
      });
      reset.setAttribute('data-cmp-action', 'reset');
      buttons.appendChild(reset);
      toolbar.appendChild(buttons);
      mount.appendChild(toolbar);
      var scroll = el('div', 'smw-cmp__horizontal');
      scroll.setAttribute('role', 'region');
      scroll.setAttribute('tabindex', '0');
      scroll.setAttribute('aria-label', isEnglish ? 'Model comparison' : 'Comparaison des modèles');
      var grid = el('div', 'smw-cmp__grid');
      for (var i = 0; i < SLOTS; i++) grid.appendChild(renderCard(i));
      scroll.appendChild(grid);
      scroll.appendChild(renderTable());
      mount.appendChild(scroll);
      root.classList.add('is-ready');
    }

    render();
  }

  function start() {
    var roots = document.querySelectorAll('[data-smw-cmp]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  // Keep the comparison interactive when Shopify reloads the section in its editor.
  document.addEventListener('shopify:section:load', start);
})();
